__turbopack_context__.v({
  "bottomSheet": "rB14dq_bottomSheet",
  "offerPill": "rB14dq_offerPill",
  "offerPillWrap": "rB14dq_offerPillWrap",
  "root": "rB14dq_root",
});
